var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgConfiguration = function SvgConfiguration(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 14,
    "data-width-20": 17,
    "data-width-24": 20,
    "data-width-28": 24,
    viewBox: "0 0 10 10",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M.4.4h3.2v3.2H.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.6,
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M2 4v1.111h6V6.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConfiguration);
export default ForwardRef;